import { getIdentity } from '@sdc/auth';
import { authLink } from './authLink';

/**
 * Setzt die Session aus den Tokens des E-Mail-Links.
 *
 * Warum explizit und nicht ueber `detectSessionInUrl`: Links, die
 * **serverseitig** erzeugt werden – Admin-Invite, Recovery per API – liefern die
 * Tokens im URL-Hash (Implicit). Auf dieses Zusammenspiel aus
 * Library-Initialisierung, geraeumtem Hash und React-StrictMode zu bauen hat
 * genau eine leere Seite produziert. Hier ist der Ablauf deterministisch:
 * `authLink` sichert die Tokens beim Modul-Laden, diese Funktion tauscht sie
 * gegen eine Session.
 *
 * In-Browser gestartete Flows (Login-Magic-Link, "Passwort vergessen?") laufen
 * weiter ueber PKCE mit `?code=` und brauchen das hier nicht.
 */
let started: Promise<{ ok: boolean; error: string | null }> | null = null;

export function consumeAuthTokens(): Promise<{ ok: boolean; error: string | null }> {
  if (started) return started;

  const { accessToken, refreshToken } = authLink;
  if (!accessToken || !refreshToken) {
    started = Promise.resolve({ ok: false, error: null });
    return started;
  }

  started = getIdentity()
    .auth.setSession({ access_token: accessToken, refresh_token: refreshToken })
    .then(({ data, error }) => ({
      ok: Boolean(data.session) && !error,
      error: error?.message ?? null,
    }))
    .catch((err: unknown) => ({
      ok: false,
      error: err instanceof Error ? err.message : String(err),
    }));

  return started;
}
